import type {AppThunk} from '../../../../../actions/types'
import {getAgentPreviewsArg} from '../../../../../rest/agents'
import {loadEndpoint} from '../../../../../routes/loadEndpoint'
import type {LoadedEndpoints} from '../../../../../routes/loadEndpoint'
import {restApi} from '../../../../../services/rest'

export const preloadFavoriteAgentPools = (): AppThunk<LoadedEndpoints> => dispatch => [
  dispatch(loadEndpoint(restApi.endpoints.getAllAgentPreviewsNormalized, getAgentPreviewsArg())),
]
